import React from "react";
import styles from "./Section7.module.scss";

export const Section7 = function () {
  return (
    <section className={`${styles.container} cc--component-container`}>
      <section id="video" className={styles.content}>
        <span className={`${styles.headline} title`}>WHAT&rsquo;S IN STORE</span>
        <span className={styles.subHeadline}>View exclusive highlights from the course in this trailer:</span>
        <iframe
          src="https://www.youtube.com/embed/nDNnvFxmHBQ"
          className="embed-responsive-item"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </section>
    </section>
  );
};
